module.exports = __webpack_public_path__ + "img/footer-back-mobile.1ee1a08f.png";